/**
 * available, ordered checkout steps
 */
export enum CheckoutStepType {
  BeforeCheckout,
  Addresses,
  Shipping,
  Payment,
  Review,
  Receipt,
}
